import { FC, useEffect, useState } from 'react';
import {
  Box,
  Fab,
  Fade,
  Tooltip
} from '@material-ui/core';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import PropTypes from 'prop-types';

const ScrollToTop: FC<{ comp: any; isBottom?: boolean; isNormalDiv?: boolean; }> = ({ comp, isBottom, isNormalDiv }) => {
  const [isTop, setTop] = useState<boolean>(true);
  const handleScroll = () => {
    if (isNormalDiv) {
      comp.current.scrollTop = 0;
    } else {
      // eslint-disable-next-line no-underscore-dangle
      comp.current._container.scrollTop = 0;
    }
  };

  useEffect(() => {
    if (isNormalDiv) {
      if (comp.current) {
        // eslint-disable-next-line no-underscore-dangle
        comp.current.addEventListener('scroll', () => {
          // eslint-disable-next-line no-underscore-dangle
          setTop(comp.current.scrollTop === 0);
        });
      }
    } else {
      // eslint-disable-next-line
      if (comp.current._container) {
        // eslint-disable-next-line no-underscore-dangle
        comp.current._container.addEventListener('scroll', () => {
          // eslint-disable-next-line no-underscore-dangle
          setTop(comp.current._container.scrollTop === 0);
        });
      }
    }
  }, [comp]);

  return (
    <Box
      sx={{
        position: 'fixed',
        right: 0,
        m: 5,
        bottom: isBottom ? 0 : 56,
        zIndex: (theme) => theme.zIndex.speedDial,
        width: 60,
        height: 60
      }}
    >
      <Fade
        in={!isTop}
        timeout={150}
      >
        <Tooltip
          title="Scroll to top"
          placement="left"
        >
          <Fab
            id="scroll-to-top-but"
            color="primary"
            onClick={handleScroll}
          >
            <ExpandLessIcon
              sx={{
                fontSize: 40
              }}
            />
          </Fab>
        </Tooltip>
      </Fade>
    </Box>
  );
};

ScrollToTop.propTypes = {
  comp: PropTypes.any,
  isBottom: PropTypes.bool,
  isNormalDiv: PropTypes.bool
};

export default ScrollToTop;
